<!-- This file is for desktop and tablet sidebar fare details -->
<template>
  <div class="fare_desc_col">
    <div class="fare_header">
      <h4>Fare Types</h4>
    </div>
    <v-container
      id="scroll-target"
    >
      <v-flex class="scroll">
			<div :class="{ selected: isShown('Premium') }" @click="showFare('Premium')">
			  <div class="padded">
				 <v-layout row align-center>
					<v-flex grow>
					  <v-layout row wrap>
						 <v-flex shrink class="pr-1">
						   <h4>Premium Fare</h4>
						 </v-flex>
						 <v-flex>
						   <SelectedFareMarkers fare="Premium" />
						 </v-flex>
					  </v-layout>
					</v-flex>
					<v-flex xs1>
					  <transition name="flip" v-if="isShown('Premium')">
						 <v-icon
						   small
						 >
						   keyboard_arrow_up
						 </v-icon>
					  </transition>
					  <transition name="flip" v-else>
						 <v-icon small>keyboard_arrow_down</v-icon>
					  </transition>
					</v-flex>
				 </v-layout>
				 <ul v-if="isShown('Premium')">
					<li>
					  <strong>Fully refundable</strong> up to <strong style="color:#b52200">1 hour prior to departure</strong>
					</li>
					<li><strong>Changeable</strong> up to <strong style="color:#b52200">1 hour prior to departure</strong></li>
					<li>
					  Baggage Allowance is <strong style="color:#b52200">50 lbs</strong>.
					  <em>Excess baggage travels space available ${{ baggageFee }}/lb</em>
					</li>
					<li>
					  <strong style="color:#b52200">5 days free</strong> parking at our {{ parkingDesc }}
					</li>
				 </ul>
			  </div>
			</div>
        <div :class="{ selected: isShown('Classic') }" @click="showFare('Classic')">
          <div class="padded">
            <v-layout row align-center>
              <v-flex grow>
                <v-layout row wrap>
                  <v-flex shrink class="pr-1">
                    <h4>Classic Fare</h4>
                  </v-flex>
                  <v-flex>
                    <SelectedFareMarkers fare="Classic" />
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-layout>
              </v-flex>
              <v-flex xs1>
                <transition name="flip" v-if="isShown('Classic')">
                  <v-icon
                    small
                  >
                    keyboard_arrow_up
                  </v-icon>
                </transition>
                <transition name="flip" v-else>
                  <v-icon small>keyboard_arrow_down</v-icon>
                </transition>
              </v-flex>
            </v-layout>
            <ul v-if="isShown('Classic')">
              <li>
                <strong>Fully refundable</strong> up to <strong style="color:#b52200">3 hours prior to departure</strong>
              </li>
              <li><strong style="color:#b52200">Only 1 change allowed up to 3 hours prior to departure</strong> to an equal or greater fare</li>
              <li>
                Baggage Allowance is <strong>35 lbs</strong>.
                <em>Excess baggage travels space available ${{ baggageFee }}/lb</em>
              </li>
              <li>
                Up to <strong style="color:#b52200">3 days free parking</strong>, based on availability,
                at our {{ parkingDesc }}
              </li>
							<li><strong>Student &amp; senior discounts only available on this fare type</strong></li>
            </ul>
          </div>
        </div>
        <div :class="{ selected: isShown('Essential') }" @click="showFare('Essential')">
          <div class="padded">
            <v-layout row align-center>
              <v-flex grow>
                <v-layout row wrap>
                  <v-flex shrink class="pr-1">
                    <h4>Essential Fare</h4>
                  </v-flex>
                  <v-flex>
                    <SelectedFareMarkers fare="Essential" />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs1>
                <v-icon small v-if="isShown('Essential')">keyboard_arrow_up</v-icon>
                <v-icon small v-else>keyboard_arrow_down</v-icon>
              </v-flex>
            </v-layout>
            <ul v-if="isShown('Essential')">
              <li class="alert">Non-Refundable</li>
              <li>
                <strong style="color:#b52200">Only 1 change allowed up to 3 hours prior to departure</strong>, to a Classic or Premium fare. Fare difference will apply and original fare remains non-refundable.
              </li>
              <li>
                Baggage Allowance is <strong style="color:#b52200">25 lbs</strong>.
                <em>Excess baggage travels space available ${{ baggageFee }}/lb</em>
              </li>
              <li>
                Up to <strong style="color:#b52200">2 days free parking</strong>, based on availability,
                at our {{ parkingDesc }}
              </li>
            </ul>
          </div>
        </div>
        <div :class="{ selected: isShown('Saver') }" @click="showFare('Saver')">
          <div class="padded">
            <v-layout row align-center>
              <v-flex grow>
                <v-layout row wrap>
                  <v-flex shrink class="pr-1">
                    <h4>Saver Fare</h4>
                  </v-flex>
                  <v-flex>
                    <SelectedFareMarkers fare="Saver" />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs1>
                <v-icon small v-if="isShown('Saver')">keyboard_arrow_up</v-icon>
                <v-icon small v-else>keyboard_arrow_down</v-icon>
              </v-flex>
            </v-layout>
            <ul v-if="isShown('Saver')">
              <li class="alert">Non-Refundable</li>
              <li>
                <strong style="color:#b52200">Only 1 change allowed up to 5 hours prior to departure</strong>, to a Classic or Premium fare. Fare difference will apply and original fare remains non-refundable.
              </li>
              <li>
                Baggage Allowance is <strong style="color:#b52200">25 lbs</strong>.
                <em>Excess baggage travels space available ${{ baggageFee }}/lb</em>
              </li>
              <li>
                Up to <strong style="color:#b52200">2 days free parking</strong>, based on availability,
                at our {{ parkingDesc }}
              </li>
            </ul>
          </div>
        </div>
        <div :class="{ selected: isShown('Prepaid') }" @click="showFare('Prepaid')">
          <div class="padded">
            <v-layout row align-center>
              <v-flex grow>
                <v-layout row wrap>
                  <v-flex shrink class="pr-1">
                    <h4>Prepaid Package Ticket Holders</h4>
                  </v-flex>
                  <v-flex>
                    <SelectedFareMarkers fare="Prepaid" />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs1>
                <v-icon small v-if="isShown('Prepaid')">keyboard_arrow_up</v-icon>
                <v-icon small v-else>keyboard_arrow_down</v-icon>
              </v-flex>
            </v-layout>
            <ul v-if="isShown('Prepaid')">
              <li>
                <a
                  href="/schedules-fares/special-offers/"
                  target="_blank"
                >
                  See here for details <v-icon>arrow_right_alt</v-icon>
                </a>
              </li>
              <li>
                <strong>Fully refundable</strong> up to <strong style="color:#b52200">1 hour</strong> prior to departure
              </li>
              <li>Changeable up to <strong style="color:#b52200">1 hour prior to departure</strong>, to an equal or greater fare tier</li>
              <li>
                Baggage Allowance is <strong>50 lbs</strong>.
                <em>Excess baggage travels space available ${{ baggageFee }}/lb</em>
              </li>
              <li>
                Up to <strong style="color:#b52200">5 days free parking</strong>, based on availability,
                at our {{ parkingDesc }}
              </li>
              <li>
                Note: Selected fares can be changed to prepaid fare on next screen
              </li>
            </ul>
          </div>
        </div>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
import Shared from "@/mixins/Shared";
import SelectedFareMarkers from "@/components/SelectedFareMarkers.vue";

export default {
  name: "FareTypes",
  props: ["fareType", "departure", "destination", "parentClass"],
  components: {SelectedFareMarkers},
  mixins: [Shared],
  data: function() {
    return {
      showFareType: [],
      offsetTop: 0
    };
  },
  computed: {
    isHidden() {
      if (this.parentClass == "selected") {
        return false;
      }
      return true;
    },
    baggageFee() {
			return "1.50";
    },
    parkingDesc() {
      if (this.form_fields.dep_loc === 1 || this.form_fields.dest_loc === 1) {
        return "YVR Terminal";
      } else {
        return "YVR or Nanaimo Terminals";
      }
    }
  },
  methods: {
    showFare(fareType) {
      if (!this.isShown(fareType)) {
        this.showFareType.push(fareType);
      } else {
        this.hideFare(fareType);
      }
    },
    hideFare(fareType) {
      if (this.isShown(fareType)) {
        const newTypes = this.showFareType.filter(type => type !== fareType);
        this.showFareType = newTypes;
      }
    },
    isShown(fareType) {
      const shown = this.showFareType.find(f => {
        return f === fareType;
      });
      if (shown === undefined) {
        return this.flightSelected(fareType);
      } else {
        return true;
      }
      return false;
    },
    flightSelected(fareType) {
      const flights = [
        this.departFlight === null ? null : this.departFlight,
        this.returnFlight === null ? null : this.returnFlight
      ];
      let match = false;
      flights.forEach(f => {
        if (f !== null && f.label === fareType) {
          match = true;
        }
      });
      return match;
    }
  },
  watch: {
    fareType(fareType) {
      this.showFareType = [fareType.label];
    }
  }
};
</script>
